"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var form_1 = require("./form");

var keyName = 'globalSearch';

var GlobalSearch = function GlobalSearch(props) {
  var _onChange = props.onChange,
      filters = props.filters,
      config = props.config;

  if (!config.search) {
    return null;
  }

  var value = filters[keyName];
  return react_1.default.createElement("div", {
    className: "pull-right"
  }, react_1.default.createElement(form_1.SearchUnit, {
    onChange: function onChange(k) {
      return _onChange({
        name: keyName,
        value: k.value
      });
    },
    name: keyName,
    value: value
  }));
};

exports.default = GlobalSearch;